// =========================================================================
// ==           *** PRODUCTION-READY COMPLETE SCRIPT ***                  ==
// =========================================================================
// This final script combines all functionalities:
// 1. The non-destructive UI enhancements for the main options (jump-free).
// 2. The custom preview modal UI.
// 3. The logic to enable the sticky desktop preview.
// All console.log statements have been removed for a clean production run.
// =========================================================================

// 立即执行添加加载提示，确保在页面渲染初期就显示
(function () {
  // 使用MutationObserver监听DOM变化，在product-form__buttons出现的同时立即添加提示
  function setupLoadingNoticeObserver() {
    // 如果DOM已经可用，立即设置Observer
    if (document.body) {
      startObserving();
    } else {
      // 如果DOM还不可用，等待DOM加载
      document.addEventListener("DOMContentLoaded", startObserving, {
        once: true,
      });
    }
  }

  function startObserving() {
    // 首先检查是否已经存在
    let productFormButtons = document.querySelector(".product-form__buttons");
    if (productFormButtons && !document.querySelector(".loading-notice")) {
      addLoadingNotice(productFormButtons);
      return;
    }

    // 创建MutationObserver监听整个文档的变化
    const observer = new MutationObserver(function (mutations) {
      for (let mutation of mutations) {
        // 检查新添加的节点
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          for (let node of mutation.addedNodes) {
            // 检查节点本身
            if (
              node.nodeType === 1 &&
              node.classList &&
              node.classList.contains("product-form__buttons")
            ) {
              addLoadingNotice(node);
              observer.disconnect();
              return;
            }

            // 检查节点内部
            if (node.nodeType === 1) {
              const buttons = node.querySelector(".product-form__buttons");
              if (buttons && !document.querySelector(".loading-notice")) {
                addLoadingNotice(buttons);
                observer.disconnect();
                return;
              }
            }
          }
        }
      }
    });

    // 开始监听整个文档的变化
    observer.observe(document.documentElement || document.body, {
      childList: true,
      subtree: true,
    });

    // 10秒后停止监听，避免内存泄漏
    setTimeout(function () {
      observer.disconnect();
    }, 10000);
  }

  function addLoadingNotice_(productFormButtons) {
    if (!document.querySelector(".loading-notice")) {
      let loadingNotice = document.createElement("div");
      loadingNotice.className = "loading-notice";
      loadingNotice.textContent = "The customization is loading...";
      productFormButtons.parentNode.insertBefore(
        loadingNotice,
        productFormButtons
      );
    }
  }

  function addLoadingNotice(productFormButtons) {
    if (!document.querySelector(".loading-notice")) {
      // 创建加载提示
      let loadingNotice = document.createElement("div");
      loadingNotice.className = "loading-notice";
      loadingNotice.textContent = "The customization is loading...";
      productFormButtons.parentNode.insertBefore(
        loadingNotice,
        productFormButtons
      );

      // 禁用所有可能的添加到购物车按钮
      const buttons = document.querySelectorAll('button[name="add"] ');

      buttons.forEach((button) => {
        // 添加禁用属性
        // button.setAttribute('disabled', 'disabled');
        // button.setAttribute('aria-disabled', 'true');

        // 添加禁用样式
        button.style.opacity = "0.5";
        button.style.cursor = "not-allowed";

        // 保存原始文本以便之后恢复
        const originalText =
          button.querySelector("span")?.textContent || button.textContent;
        button.dataset.originalText = originalText;

        // 更新按钮文本
        const textSpan = button.querySelector("span") || button;
        textSpan.textContent = "Please wait...";

        // 显示加载动画（如果存在）
        const spinner = button.querySelector(
          ".loading__spinner, .t4s-loading__spinner"
        );
        if (spinner) {
          spinner.removeAttribute("hidden");
          spinner.classList.remove("hidden");
        }
      });
    }
  }

  // 立即执行
  setupLoadingNoticeObserver();
})();

// 主脚本
(function () {
  // --- PART 1: CORE HELPER FUNCTIONS ---
 /**
   * 带有时间戳和标签的日志记录器，方便调试。
   * @param {string} tag - 日志标签，例如 'Enhancements'
   * @param {...any} messages - 要记录的信息
   */
  function log(tag, ...messages) {
    // 在生产环境中可以关闭日志，只需在此处添加一个判断条件
    // if (window.location.hostname.includes('localhost')) {
      const timestamp = new Date().toISOString().split('T')[1].slice(0, -1); // 格式如 14:30:05.123
      // console.log(
      //  `%c[${timestamp}] [${tag}]`,
      //  'color: #3498db; font-weight: bold;',
      //  ...messages
      //);
    // }
  }
  const doWhileCheck = async (func, options) => {
    let count = 0;
    const {
      waitTime = 100,
      overCount = Infinity,
      success,
      fail,
      next,
    } = options;
    const sleep = async (time) =>
      time > 0
        ? new Promise((resolve) => setTimeout(() => resolve(true), time))
        : Promise.resolve(false);
    while (true) {
      if (func()) {
        if (typeof success === "function") await success();
        break;
      } else {
        count++;
        if (overCount !== Infinity && count > overCount) {
          if (typeof fail === "function") fail();
          break;
        } else {
          if (typeof next === "function") next(count);
          await sleep(waitTime);
        }
      }
    }
  };

  function Toast(msg, duration = 3000) {
    var m = document.createElement("div");
    m.innerHTML = "<div>" + msg + "</div>";
    m.style.cssText =
      "width: 60%; min-width:150px; padding:10px 4px; display:flex; align-items:center; justify-content: center;opacity: 0.7; color:rgb(255, 255, 255); min-height:60px; line-height:24px; text-align:center; border-radius:5px; position:fixed; top:40%; left:20%; z-index:9999999; background:rgb(0, 0, 0); font-size: 18px;";
    document.body.appendChild(m);
    setTimeout(() => {
      var d = 0.5;
      m.style.transition = `opacity ${d}s ease-in`;
      m.style.opacity = "0";
      setTimeout(() => document.body.removeChild(m), d * 1000);
    }, duration);
  }

  // --- PART 2: MAIN LOGIC INITIALIZATION ---

  document.addEventListener("DOMContentLoaded", async function () {
    await doWhileCheck(() => typeof window.jQuery === "function", {
      success: () => {
        const $ = window.jQuery;
        $(document).ready(function () {
          runMainOptionsEnhancements($);
          runPreviewModalCustomizer($);
          runStickyPreviewEnabler($);
          runAccordionJumpFix();
          runWishlistButtonFix();
        });
      },
      fail: () => console.error("Customily Fix: jQuery did not load."),
    });
  });


    // --- MODULE A: Main Options Enhancements (Jump-Free) ---
  function runMainOptionsEnhancements($) {
    log('Enhancements', '脚本启动，开始执行UI增强流程。');

    // 移除加载提示的函数保持不变
    function removeLoadingNotice() {
      const loadingNotice = document.querySelector(".loading-notice");
      if (loadingNotice) {
        log('Enhancements', '正在移除加载提示...');
        loadingNotice.remove();
      }
      const buttons = document.querySelectorAll('button[name="add"]');
      buttons.forEach((button) => {
        button.style.opacity = "";
        button.style.cursor = "";
        if (button.dataset.originalText) {
          const textSpan = button.querySelector("span") || button;
          textSpan.textContent = button.dataset.originalText;
        }
        const spinner = button.querySelector(".loading__spinner, .t4s-loading__spinner");
        if (spinner) {
          spinner.setAttribute("hidden", "");
          spinner.classList.add("hidden");
        }
      });
      log('Enhancements', '所有按钮已恢复正常状态。');
    }

    // --- 关键修改：将流程串行化 ---

    // 步骤 1: 等待 Customily 核心容器 #customily-options
    log('Enhancements', '步骤 1: 正在等待 Customily 核心容器 #customily-options...');
    doWhileCheck(() => $("#customily-options").length > 0, {
      waitTime: 250,
      overCount: 500,// 将超时延长到15秒，以应对慢网络情况
      success: () => {
        log('Enhancements', '✅ 步骤 1 [成功]: 找到 #customily-options。现在执行标题添加。');
        const customilyOptions = $("#customily-options");

        // 执行操作 1: 添加标题
        if (customilyOptions.find(".option_title").length === 0) {
          log('Enhancements', '  -> 正在添加 "Personalized options" 标题...');
          customilyOptions.prepend('<div class="option_title">Personalized options</div>');
        } else {
          log('Enhancements', '  -> 标题已存在，跳过添加。');
        }
        customilyOptions.addClass("customily-container--styled");
        log('Enhancements', '  -> 已为 #customily-options 添加样式类。');

        // 串行执行：在步骤1成功后，才开始步骤2
        waitForPreviewButtonAndFinalize($);
      },
      fail: () => {
        log('Enhancements', '❌ 步骤 1 [失败]: 等待 #customily-options 超时！后续步骤将无法执行。');
        // 即使失败，也要移除加载提示，避免用户无法操作
        removeLoadingNotice();
      }
    });

    // 步骤 2: 等待预览按钮，并完成后续操作
    function waitForPreviewButtonAndFinalize($) {
      log('Enhancements', '步骤 2: 正在等待预览按钮 .customily-preview-button...');
      doWhileCheck(() => $(".customily-preview-button").length > 0, {
        waitTime: 250,
        overCount: 40, // 10秒
        success: () => {
          log('Enhancements', '✅ 步骤 2 [成功]: 找到 .customily-preview-button。现在执行按钮移动。');
          const productFormButtons = $(".product-form__buttons");

          if (productFormButtons.length > 0) {
            // 执行操作 2: 移动按钮
            log('Enhancements', '  -> 正在移动预览按钮...');
            if ($(".preview-btn").length === 0) {
              productFormButtons.before('<div class="preview-btn"></div>');
              log('Enhancements', '  -> 创建了 .preview-btn 容器。');
            }
            const previewButton = $(".customily-preview-button");
            if (!previewButton.parent().is(".preview-btn")) {
              previewButton.appendTo(".preview-btn");
              log('Enhancements', '  -> 已将预览按钮移入 .preview-btn。');
            } else {
              log('Enhancements', '  -> 预览按钮已在正确位置，跳过移动。');
            }
          } else {
            log('Enhancements', '⚠️ 警告: 未找到 .product-form__buttons，无法移动预览按钮。');
          }

          // 所有操作成功，执行收尾工作
          log('Enhancements', '🚀 所有UI增强操作已成功完成。');
          removeLoadingNotice();
          addBottomPreviewButton($);
          runWishlistButtonFix();
        },
        fail: () => {
          log('Enhancements', '❌ 步骤 2 [失败]: 等待 .customily-preview-button 超时！无法移动按钮。');
          // 同样，即使失败也要移除加载提示
          removeLoadingNotice();
        }
      });
    }
  }
  
  // --- MODULE A: Main Options Enhancements (Jump-Free) ---
  function runMainOptionsEnhancements_($) {
    // ***************************************************************
    // **                      TIMING FIX APPLIED HERE                  **
    // ***************************************************************

    // STEP 1: 不再需要在这里添加加载提示，因为我们已经在脚本开始时添加了提示
    // 只需要获取引用以便后续操作
    const productFormButtons = $(".product-form__buttons");

    // STEP 2: Wait for the main Customily options container to appear.
    doWhileCheck(() => $("#customily-options").length > 0, {
      waitTime: 250,
      overCount: 120,
      success: () => {
        const customilyOptions = $("#customily-options");
        if (customilyOptions.find(".option_title").length === 0) {
          customilyOptions.prepend(
            '<div class="option_title">Personalized options</div>'
          );
        }
        customilyOptions.addClass("customily-container--styled");
      },
    });

    function removeLoadingNotice() {
      // 移除加载提示
      const loadingNotice = document.querySelector(".loading-notice");
      if (loadingNotice) {
        loadingNotice.remove();
      }

      // 恢复所有按钮
      const buttons = document.querySelectorAll('button[name="add"]');
      buttons.forEach((button) => {
        // 移除禁用状态
        // button.removeAttribute('disabled');
        // button.removeAttribute('aria-disabled');

        // 恢复样式
        button.style.opacity = "";
        button.style.cursor = "";

        // 恢复原始文本
        if (button.dataset.originalText) {
          const textSpan = button.querySelector("span") || button;
          textSpan.textContent = button.dataset.originalText;
          delete button.dataset.originalText;
        }

        // 隐藏加载动画
        const spinner = button.querySelector(
          ".loading__spinner, .t4s-loading__spinner"
        );
        if (spinner) {
          spinner.setAttribute("hidden", "");
          spinner.classList.add("hidden");
        }
      });
    }

    // STEP 3: Wait for the Customily PREVIEW button to appear, THEN REMOVE the notice.
    doWhileCheck(() => $(".customily-preview-button").length > 0, {
      waitTime: 250,
      overCount: 40,
      success: () => {
        if (productFormButtons.length > 0) {
          if ($(".preview-btn").length === 0) {
            productFormButtons.before('<div class="preview-btn"></div>');
          }
          const previewButton = $(".customily-preview-button");
          if (!previewButton.parent().is(".preview-btn")) {
            previewButton.appendTo(".preview-btn");
          }
          // The notice is removed only when the preview button is ready.
          // $('.loading-notice').remove();
          removeLoadingNotice();
        }
        addBottomPreviewButton($);
        runWishlistButtonFix();
      },
      fail: () => {
        // Also remove the notice if the preview button fails to appear, to not leave it hanging.
        removeLoadingNotice();
      },
    });
  }

  function addBottomPreviewButton($) {
    if ($("#print10-preview-btn").length === 0) {
      $("body").append(
        '<div class="print10-bottom-padding"></div><div class="print10-preview-btn" id="print10-preview-btn">Preview Your Design</div>'
      );
      $("body").on("click", "#print10-preview-btn", function () {
        $(".customily-preview-button").trigger("click");
      });
    }
  }

  // --- NEW MODULE E: Wishlist Button Visibility Fix ---
  function runWishlistButtonFix() {
    const wishlistWrapper = document.querySelector(
      ".product-page-wishlist-wrapper"
    );

    if (wishlistWrapper) {
      // Use MutationObserver to be absolutely sure we catch any late style changes.
      const observer = new MutationObserver(() => {
        // Check if Customily has hidden our button.
        if (wishlistWrapper.style.display === "none") {
          // If so, force it to be visible again.
          wishlistWrapper.style.display = "block"; // Or 'flex', depending on its default style.
        }
      });

      // Start observing the wishlist wrapper for attribute changes (like style="display:none").
      observer.observe(wishlistWrapper, { attributes: true });

      // Also, do an initial check immediately.
      if (wishlistWrapper.style.display === "none") {
        wishlistWrapper.style.display = "block";
      }
    }
  }

  function runPreviewModalCustomizer($) {
    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      const modal = document.querySelector(".customily-modal-preview-only");
      if (!modal || modal.style.display === "none" || !modal.getClientRects().length) return;
      modal.querySelector(".customily-close-button")?.click();
    });
    const observer = new MutationObserver((mutations, obs) => {
      const modalContainer = document.querySelector(
        ".customily-modal-preview-only"
      );
      if (!modalContainer || modalContainer.style.display === "none") {
        return;
      }

      const previewWrapper = modalContainer.querySelector(
        ".cl-preview-wrapper"
      );
      // 检查是否已处理
      if (
        !previewWrapper ||
        previewWrapper.querySelector(".customily-modal-preview-header")
      ) {
        return;
      }

      const customilyPreviewElement = previewWrapper.querySelector(
        "canvas, .cl-preview-image"
      );
      if (!customilyPreviewElement) {
        return;
      }

      const $previewWrapper = $(previewWrapper);

      // 1. 使用 prepend 注入头部和提示
      const headerAndNoticeHtml = `<div class="customily-modal-preview-header">
                
                <div class="customily-modal-preview-title">Please check the preview carefully</div>
              </div>
           <div class="customily-modal-preview-notice">
                <div class="notice-content">Make sure the below customization is correct to receive your item faster </div>
                </div>
        `;
      $previewWrapper.prepend(headerAndNoticeHtml);

      // 2. 【最关键的操作】找到原生关闭按钮，并把它移动到我们新创建的头部里
      // 我们需要找到 .main 容器下的关闭按钮
      const nativeCloseButton = modalContainer.querySelector(
        ".customily-close-button"
      );
      const newHeader = previewWrapper.querySelector(
        ".customily-modal-preview-header"
      );
      if (nativeCloseButton && newHeader) {
        $(nativeCloseButton).appendTo(newHeader);
        nativeCloseButton.setAttribute("role", "button");
        nativeCloseButton.setAttribute("tabindex", "0");
        nativeCloseButton.setAttribute("aria-label", "Close preview");
        nativeCloseButton.addEventListener("keydown", (event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            nativeCloseButton.click();
          }
        });
      }

      // 3. 使用 append 注入底部
      const footerHtml = `
            <div class="customily-modal-preview-footer">
                <button type="button" class="modal-add-to-cart-btn product-form__submit button button--full-width button--primary">
                    <span>Add to cart</span>
                </button>
            </div>
        `;
      $previewWrapper.append(footerHtml);

      // 4. 为新注入的按钮绑定事件
      $("body")
        .off("click", ".customily-modal-preview-footer button")
        .on("click", ".customily-modal-preview-footer button", function () {
          $("#customily-cart-btn")?.trigger("click");

          setTimeout(() => {
            if (
              $(".customily-required-label span:visible").length === 0 &&
              typeof Toast === "function"
            ) {
              Toast(
                "Your design is generating, please wait for about 3 seconds…"
              );
            }
          }, 200);

          // 触发原生关闭按钮
          $(".customily-modal-preview-only .customily-close-button").trigger(
            "click"
          );
        });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style"],
    });
  }

  // --- MODULE C: Sticky Desktop Preview Enabler ---
  function runStickyPreviewEnabler($) {
    let observer;
    const findAndEnableSticky = () => {
      const accordion = document.querySelector(
        "#customily-personalize-accordion > div"
      );
      if (accordion && accordion.children.length > 0) {
        if (observer) observer.disconnect();

        const findPreviewHandler = () => {
          let result = null;
          document.querySelectorAll("*").forEach((el) => {
            if (el.__vue__?.livePreviewHandler)
              result = el.__vue__.livePreviewHandler;
          });
          return result;
        };

        const instance = findPreviewHandler();
        if (instance && !instance.isMobile) {
          instance.setStickyPreview();
        }
      }
    };

    observer = new MutationObserver(findAndEnableSticky);
    observer.observe(document.body, { childList: true, subtree: true });
  }
// ========================================================================
// == FINAL SOLUTION - A Pure Replication of T4S Theme's Accordion Logic ==
// ========================================================================
// This script perfectly mimics the functionality of the provided T4S Theme JS.
// It uses jQuery's slideDown/slideUp, which is proven to work smoothly
// with the sticky layout's MutationObserver. No complex theories, just replication.

function runAccordionJumpFix() {

    // A simple console log for confirmation
    // console.log('[Accordion Final Replication] Initializing...');
    
    // Ensure jQuery is available
    if (typeof window.jQuery !== 'function') {
        console.error('[Accordion Final Replication] jQuery is not available. Aborting.');
        return;
    }
    const $ = window.jQuery;

    // The container for all accordion items on your page
    const productInfoContainer = $('.product__info-container');
    if (productInfoContainer.length === 0) {
        return;
    }

    // The clickable buttons in your existing DOM
    const accordionTriggers = productInfoContainer.find('button.accordion-toggle');
    if (accordionTriggers.length === 0) {
        return;
    }
    
    // --- Forcefully remove any existing event listeners from the theme ---
    // This is a crucial step to ensure our script is the ONLY one in control.
    accordionTriggers.each(function() {
        const newTrigger = this.cloneNode(true);
        this.parentNode.replaceChild(newTrigger, this);
    });

    // Re-select the new, clean triggers and attach our single, definitive event handler
    const newAccordionTriggers = productInfoContainer.find('button.accordion-toggle');

    newAccordionTriggers.on('click.final-replication', function(event) {
        event.preventDefault(); // Prevent default button behavior

        const $clickedButton = $(this);
        const $contentToToggle = $clickedButton.next('.accordion__content');

        // Check if the clicked item is already open
        const isAlreadyOpen = $clickedButton.attr('aria-expanded') === 'true';
        
        // --- This logic directly mirrors the T4S Theme script ---

        // Step 1: Find any other accordion item that is currently open
        const $currentlyOpenButton = newAccordionTriggers.not($clickedButton).filter('[aria-expanded="true"]');

        // Step 2: If another item is open, close it smoothly and quickly
        if ($currentlyOpenButton.length > 0) {
            const $otherContent = $currentlyOpenButton.next('.accordion__content');
            $currentlyOpenButton.attr('aria-expanded', 'false');
            // Use a faster duration (150ms) for closing other items, just like T4S
            $otherContent.stop(true, true).slideUp(150, function() {
                $(this).removeClass('is-open-for-js'); // Clean up class after animation
            });
        }
        
        // Step 3: Toggle the clicked item
        if (isAlreadyOpen) {
            // If it was open, close it
            $clickedButton.attr('aria-expanded', 'false');
            $contentToToggle.stop(true, true).slideUp(300, function() {
                $(this).removeClass('is-open-for-js');
            });
        } else {
            // If it was closed, open it
            $clickedButton.attr('aria-expanded', 'true');
            // Add the helper class BEFORE starting the animation
            $contentToToggle.addClass('is-open-for-js'); 
            $contentToToggle.stop(true, true).slideDown(300);
        }
    });

    // console.log(`[Accordion Final Replication] ${newAccordionTriggers.length} listeners attached. Ready.`);
}

  
})();

